module.exports = __webpack_public_path__ + "img/wave-bot.6cd18bc0.png";